const getFinalPrice = ({ subTotal, taxTotal, currencyCode, total }) => {
  const price = total
    ? parseFloat(total)
    : parseFloat(subTotal) + parseFloat(taxTotal)
  return `${currencyCode} ${price.toLocaleString('es-AR')}`
}

export default getFinalPrice
